customElements.define('component-overlay', class Overlay extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const isCartDrawerOpen = window.localStorage.getItem('isCartDrawerOpen') === 'true';
      if (isCartDrawerOpen) {
        window.broadcastChannel.dispatchEvent('close-cart-drawer');
      }
    });

    this.setEventListeners();
  }

  setEventListeners() {
    window.addEventListener('show-overlay', () => {
      this.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('overflow-hidden');
    });

    window.addEventListener('hide-overlay', () => {
      this.classList.add('hidden');
      document.body.style.overflow = 'unset';
      document.body.classList.add('overflow-unset');
    });
  }
});
